import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "react-responsive-modal";
import "./ProfilePictureModal.scss";

const ProfilePictureModal = (props) => {
  const { open, picture, onCancel, onSave, t, error } = props;
  return (
      <Modal center open={open} onClose={onCancel} classNames={{ modal: "profile-picture-modal" }}>
        <p className="title">{t("profile_picture_preview")}</p>
        <div className="profile-picture">
          <img className="picture" src={picture} alt="preview" />
        </div>
        <div className="bottom-section">
          {error && <p className="error">{t(error)}</p>}
          <input
            className="save-button"
            type="submit"
            value={t("save")}
            onClick={onSave}
          />
          <input
            className="cancel-button"
            type="reset"
            value={t("cancel")}
            onClick={onCancel}
          />
        </div>
      </Modal>
  );
};

export default withTranslation()(ProfilePictureModal);
